const mediaItems = [
  {
    title: '顶流男星夜会神秘女 全程跟拍实况',
    duration: '08:32',
    views: '128万',
    tag: '爆料',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20art%20representing%20celebrity%20paparazzi%20and%20entertainment%20news%20video%20thumbnail%2C%20warm%20orange%20and%20coral%20gradients%2C%20modern%20minimalist%20style%2C%20geometric%20play%20button%20shape%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-01-celeb&orientation=landscape',
  },
  {
    title: '吃瓜大赛决赛 神操作连续高能',
    duration: '15:20',
    views: '96万',
    tag: '精选',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20art%20representing%20competition%20highlights%20and%20exciting%20moments%2C%20warm%20gold%20and%20amber%20gradients%2C%20dynamic%20flowing%20shapes%2C%20modern%20editorial%20style%2C%20clean%20background%2C%20no%20text%20no%20people&width=800&height=450&seq=media-02-contest&orientation=landscape',
  },
  {
    title: '主播带货翻车现场 弹幕笑到头掉',
    duration: '06:18',
    views: '85万',
    tag: '搞笑',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20colorful%20digital%20art%20representing%20funny%20live%20streaming%20moment%2C%20warm%20peach%20and%20soft%20orange%20tones%2C%20playful%20geometric%20shapes%2C%20modern%20minimalist%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-03-funny&orientation=landscape',
  },
  {
    title: '综艺录制争执全记录 名场面回顾',
    duration: '12:05',
    views: '112万',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20digital%20art%20representing%20TV%20show%20conflict%20scene%2C%20warm%20terracotta%20and%20coral%20gradients%2C%20bold%20geometric%20contrast%2C%20modern%20editorial%20quality%2C%20clean%20background%2C%20no%20text%20no%20people&width=800&height=450&seq=media-04-drama&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🎬 吃瓜视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            热门吃瓜短视频与直播回放，点击即看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group relative bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200/50 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-white text-xs font-medium rounded whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 rounded-full text-sm text-foreground-500 cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors">
            查看更多视频
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </section>
  );
}